import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppSelector } from './hooks';
import { useTheme } from '@src/theme/useTheme';
import { resolveSiteSeason } from '@src/theme/siteSeason';

/** Updates the base theme; BoxAppearance owns the independent game override. */
export function UserAppearance() {
  const user = useAppSelector((state) => state.session.user);
  const status = useAppSelector((state) => state.session.status);
  const { setSeason } = useTheme();
  const theme = user?.theme;
  const { pathname } = useLocation();
  const applied = useRef<{ id: number | undefined; theme: typeof theme } | null>(null);
  useEffect(() => {
    if (status !== 'ready') return;
    // Creating the organizer session must not apply its fallback appearance.
    // The wizard applies the draft theme only when its Next button is pressed.
    if (pathname === '/box/new') return;
    // A session refresh must not discard a temporary homepage preview.
    if (applied.current?.id === user?.id && applied.current?.theme === theme && applied.current) return;
    applied.current = { id: user?.id, theme };
    void setSeason(resolveSiteSeason(theme), { persist: false }).catch(() => {});
  }, [user, theme, status, setSeason, pathname]);
  return null;
}
